import { Routes, Route } from "react-router-dom";
import "./App.css";
import PortfolioApp from "./components/Portfolio";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<PortfolioApp />} />
          <Route path="/portfolio/:slug" element={<PortfolioApp />} />
          <Route path="/:section" element={<PortfolioApp />} />
        </Routes>
      </div>
    </LanguageProvider>
  );
}

export default App;
